/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { useContext, useEffect, useState } from "react"

import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import CONSTANT from "../../../constant"
import { Button } from "react-bootstrap"
import {
  GridInitializedContext,
  IsRestoreSearchingContext,
  IsSearchingContext,
  SearchResultContext,
} from "./UnsogyomuHatyusyoContext"
// TODO:ダミー
import { T運送業務発注書印刷GridItem } from "./UnsogyomuHatyusyo"
import { 積地Bindings, 卸地Bindings } from "./UnsogyomuHatyusyoConstant"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import dayjs from "dayjs"
import Decimal from "decimal.js"
import { TUnsogyomuHatyusyoPrintReq } from "../../../service/order/unsogyomuHatyusyo/TUnsogyomuHatyusyo"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import { AppDispatch } from "../../.."
import { useDispatch } from "react-redux"
import UnsogyomuHatyusyoService from "../../../service/order/unsogyomuHatyusyo/unsogyomuHatyusyoService"

/**
 * 運送業務発注書印刷grid部
 * @param props
 * @returns
 */
const UnsogyomuHatyusyoGrid: React.FC<{
  searchConditionClear?: React.MouseEventHandler<HTMLElement>
  gridId: string
  kensakubiCd: string | null | undefined
  kensakubiFrom: string | null | undefined
  kensakubiTo: string | null | undefined
  yosyaCd: string | null | undefined
  yosyaNm: string | null | undefined
  zyutyuBusyoCd: string | null | undefined
}> = (props) => {
  //#region [context]

  // ロード表示
  const { state: isSearching, setState: setIsSearching } =
    useContext(IsSearchingContext)
  //grid初期化フラグ
  const { state: gridInitialized, setState: setGridInitialized } = useContext(
    GridInitializedContext
  )
  // gridレストア完了フラグ
  const { state: isRestoreSearching, setState: setIsRestoreSearching } =
    useContext(IsRestoreSearchingContext)

  // 検索結果
  const searchResult = useContext(SearchResultContext)

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<T運送業務発注書印刷GridItem>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        支払合計: (data: T運送業務発注書印刷GridItem) => {
          const 支払運送料 = new Decimal(data.支払運送料 ?? 0)
          const 支払付帯料 = new Decimal(data.支払付帯料 ?? 0)
          const 支払高速料 = new Decimal(data.支払高速料 ?? 0)
          return 支払運送料.plus(支払付帯料).plus(支払高速料).toNumber()
        },
        受注No: (data: T運送業務発注書印刷GridItem) => {
          if (data.受注伝票番号 != null && data.受注伝票番号 !== "") {
            const text = `${data.受注伝票番号}${
              data.受注枝番 != null && data.受注枝番 > 0
                ? `-${data.受注枝番}`
                : data.複写フラグ === 1
                ? "-??"
                : ""
            }`
            return text
          } else {
            return ""
          }
        },
      },
    })

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)

    grid.refresh()
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjcGrid.FlexGrid) => {
    // header行に一行追加
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""
        if (積地Bindings.includes(c.binding)) {
          setHeaderText = "積地"
        } else if (卸地Bindings.includes(c.binding)) {
          setHeaderText = "卸地"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        c.align = "left"
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })
  }

  /**
   * 運送業務発注書印刷処理
   */
  const printUnsogyomuHatyusyo = async (
    searchCondition?: TUnsogyomuHatyusyoPrintReq
  ) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    // 検索ボタン押下時の条件から検索条件を生成
    const printCondition: TUnsogyomuHatyusyoPrintReq = {
      抽出条件_検索日コード: props.kensakubiCd,
      抽出条件_検索日To: props.kensakubiTo,
      抽出条件_検索日From: props.kensakubiFrom,
      抽出条件_傭車会社コード: props.yosyaCd,
      抽出条件_傭車会社名: props.yosyaNm,
      抽出条件_受注部所コード: props.zyutyuBusyoCd,
    }

    try {
      const service = new UnsogyomuHatyusyoService({ responseType: "blob" })
      const res = await service.printUnsogyomuHatyusyoPrint(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  //#endregion

  //#region [baseState]

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  //アラート制御
  //   const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [effect]

  //初期表示
  useEffect(() => {
    if (searchResult == null) return
    setGridData({ data: createCollectionView(searchResult, pageSize) })

    flexGrid?.refresh()
  }, [searchResult])

  //#endregion

  return (
    <>
      <FlexGridOuter
        flexGrid={flexGrid}
        setFlexGrid={setFlexGrid}
        gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
        gridData={gridData}
        setGridData={setGridData}
        pageNumber={pageNumber}
        searchConditionClear={props.searchConditionClear}
        gridId={props.gridId}
        isRestoreSearching={isRestoreSearching}
        setIsRestoreSearching={setIsRestoreSearching}
        gridInitialized={gridInitialized}
        setGridInitialized={setGridInitialized}
        pageSize={pageSize}
        setPageSize={setPageSize}
        gridInitializedHandler={gridInitializedHandler}
        gridProperties={{
          allowMerging: wjcGrid.AllowMerging.ColumnHeaders,
          headersVisibility: wjcGrid.HeadersVisibility.All,
          keyActionTab: wjcGrid.KeyAction.CycleOut,
        }}
        headerComponent={
          <div className="d-flex">
            <Button
              className="btn-done"
              disabled={
                isSearching || searchResult == null || searchResult.length <= 0
              }
              onClick={() => {
                // 印刷処理の実行
                printUnsogyomuHatyusyo()
              }}>
              <FontAwesomeIcon icon={faFileAlt} />
              運送業務発注書印刷
            </Button>
          </div>
        }>
        <wjrGrid.FlexGridColumn
          binding="傭車会社名"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={180}
          header="傭車会社"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="受注No"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={180}
          header="受注No"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積日"
          cssClassAll={"read-only-cell"}
          width={96}
          header="積日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<T運送業務発注書印刷GridItem>
            ) => {
              let dt = ""
              if (context.item.積日)
                dt = dayjs(context.item.積日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸日"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={80}
          header="卸日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<T運送業務発注書印刷GridItem>
            ) => {
              let dt = ""
              if (context.item.卸日)
                dt = dayjs(context.item.卸日).format("MM/DD")
              return <>{dt}</>
            }}
          />
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積時間"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={80}
          header="積時間"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸時間"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={80}
          header="卸時間"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地社名"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={150}
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積地市区町村"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={100}
          header="地名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地社名"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={150}
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸地市区町村"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={100}
          header="地名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="品名"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={150}
          header="品名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積載品数量"
          isReadOnly={true}
          cssClass="read-only-cell number-col"
          width={70}
          header="数量"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="単位区分名称1"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={60}
          header="単位"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払運送料"
          isReadOnly={true}
          cssClass="read-only-cell number-col"
          width={90}
          header="運送料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="支払高速料"
          isReadOnly={true}
          cssClass="read-only-cell number-col"
          width={90}
          header="高速料"></wjrGrid.FlexGridColumn>
        {/* <wjrGrid.FlexGridColumn
          binding="支払合計"
          isReadOnly={true}
          cssClass="read-only-cell number-col"
          width={90}
          header="支払額"></wjrGrid.FlexGridColumn> */}
        <wjrGrid.FlexGridColumn
          binding="輸送備考"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={250}
          header="輸送備考"></wjrGrid.FlexGridColumn>
      </FlexGridOuter>
    </>
  )
}

export default UnsogyomuHatyusyoGrid
